'use strict';

/*jshint unused: false*/
var fcoGroupComponent = {
  restrict: 'E',
  replace: true,
  transclude: true,
  bindings: {
    job: '<',
    product: '<',
    isPreviewVisible: '=',
  },
  controller: /*@ngInject*/ function (JobService, $q, $scope) {
    var _self = this;
    _self.fcoImages = [];

    //Data to initialize IMG Hero
    _self.imgHero = {
      active: false,
      src: '',
    };

    _self.getSrc = function (image) {
      return JobService.getImageByType(image, 'all');
    };

    _self.showHero = function (image) {
      _self.isPreviewVisible = true;
      _self.imgHero.active = true;
      _self.imgHero.src = JobService.getImageByType(image, 'large');
      _self.imgHero.name = image.fileName;
      _self.imgHero.type = 'FCO';
    };

    _self.$onChanges = function (changesObj) {
      if (_self.product) {
        _self.product.assets.forEach((asset) => {
          if (asset.viewCode.toLowerCase().startsWith('fco')) {
            var newAsset = true;
            _self.fcoImages.forEach((image) => {
              if (image.id === asset.id) {
                newAsset = false;
              }
            });
            if (newAsset) {
              _self.fcoImages.push(asset);
            }
          }
        });
      }
    };
  },
  templateUrl: 'templates/partials/ui/fcoGroup.tpl.html',
};

module.exports = fcoGroupComponent;
